import React, { useCallback, useState } from "react";
import Modal from "../Modal";
import styles from "./styles.module.css";
import existingZupeeUserImage from "../../assets/existing-zupee-user.svg";
import ImageComponent from "../ImageComponent";
import { clsx } from "clsx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CLEVERTAP_EVENTS, NAVIGATION_ROUTES } from "../../constant";
import { pushClevertapEvent } from "../../utils/analytics/clevertap";
interface ExistingZupeeUserModalProps { 
  isExistingUser: boolean;
  setIsExistingUser: (isExistingUser: boolean) => void;
}

function ExistingZupeeUserModal({ isExistingUser, setIsExistingUser }: ExistingZupeeUserModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Clevertap Event
  const handleClickCTEvent = useCallback(() => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_EXISTING_USER_PLAY_NOW);
  }, []);

  const handlePlayNow = () => {
    const url = process.env.REACT_APP_MAIN_SITE_LINK as string;
    navigate(NAVIGATION_ROUTES.HOME, { replace: true });
    setIsExistingUser(false);
    window.open(url, "_blank");
    handleClickCTEvent();
  };

  const handleClose = () => {
    setIsExistingUser(false);
    navigate(NAVIGATION_ROUTES.HOME, { replace: true });
  };

  return (
    <div>
      <Modal
        isOpen={isExistingUser}
        onClose={handleClose}
        className={styles.modalContainer}
        overlayClassName={styles.overlay}
        modalContentClassName={styles.modalContent}
        closeOnOverlayClick={false}
      >
        <div className={styles.contentBox}>
          <div
            className={styles.crossBtn}
            onClick={handleClose}
          >
            &#10005;
          </div>
          <div className={styles.existingZupeeUserImage}>
            <ImageComponent
              src={existingZupeeUserImage}
              alt="existing-zupee-user"
            />
          </div>
          <div className={styles.existingZupeeUserText}>
            {t("existingZupeeUser")}
          </div>
          <div className={styles.existingZupeeUserTextDescription}>
            {t("continuePlayingOnFullVersionApp")}
          </div>
          <button
            className={clsx(styles.playNowBtn, "btn primaryBtn")}
            type="button"
            onClick={handlePlayNow}
          >
            {t("playNow")}
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default ExistingZupeeUserModal;
